import _ from 'lodash';
import { StyledCell } from '../Table.style';
import styled from 'styled-components';
import { ClickableTextMixin } from 'components/base/common-styles';
import { Tooltip } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import AppRouter from 'common/AppRouter';
import QueryString from 'query-string';

const StyledTotalText = styled.div`
  ${ClickableTextMixin}
`;

const StyledConnectedBranchesCell = styled(StyledCell)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const StyledConnectedBranchesTooltip = styled.div`
  & > .branch-row {
    padding: 0.5rem;
  }
`;

const ConnectedBranchesTooltip = ({ connectedBranches }) => {
  return (
    <StyledConnectedBranchesTooltip>
      {_.map(connectedBranches, branch => {
        const branchName = _.get(branch, 'name', 'N/A');
        const branchId = _.get(branch, 'id');
        const branchNameWithoutOrigin = branchName.replace(/origin\//g, '');

        return (
          <div key={branchId} className='branch-row'>
            {branchNameWithoutOrigin}
          </div>
        );
      })}
    </StyledConnectedBranchesTooltip>
  );
};

const ConnectedBranchesCell = ({ connectedBranches }) => {
  const history = useHistory();
  const totalBranches = _.size(connectedBranches);
  const isTooltipDisabled = totalBranches === 0;

  const onConnectedBranchesClick = () => {
    const branchIds = _.map(connectedBranches, ({ id }) => id);
    history.push({
      pathname: AppRouter.BRANCH.path,
      search: QueryString.stringify(
        { branch_ids: branchIds },
        { arrayFormat: 'comma' }
      )
    });
  };

  return (
    <StyledConnectedBranchesCell>
      <Tooltip
        placement='top'
        title={
          isTooltipDisabled ? (
            ''
          ) : (
            <ConnectedBranchesTooltip connectedBranches={connectedBranches} />
          )
        }
      >
        <StyledTotalText
          data-cy='total-connected-branches'
          onClick={totalBranches ? onConnectedBranchesClick : null}
        >
          {totalBranches}
        </StyledTotalText>
      </Tooltip>
    </StyledConnectedBranchesCell>
  );
};

export default ConnectedBranchesCell;
